import weightPresetsData from './weightPresets.json';
import { computeLearningConfidence } from './computeLearningConfidence';
import { computeNumberLearningRankings } from './computeRankings';
import { scorePresetForLowPercentiles } from './scorePresetForLowPercentiles';
import type {
    NumberLearningConfig,
    NumberLearningResult,
    WeightPreset,
    WeightPresetBenchmarkResult,
} from './types';

export const WEIGHT_PRESETS: WeightPreset[] = weightPresetsData.presets;

export const runWeightPresetBenchmark = (
    historico: number[][],
    maxNum: number,
    numSorteados: number,
    baseConfig: NumberLearningConfig
): WeightPresetBenchmarkResult | null => {
    if (!historico?.length || !maxNum || !WEIGHT_PRESETS.length) {
        return null;
    }

    let bestResult: NumberLearningResult | null = null;
    let bestPreset: WeightPreset | null = null;
    let bestScore = Number.NEGATIVE_INFINITY;

    WEIGHT_PRESETS.forEach((preset) => {
        const config: NumberLearningConfig = {
            ...baseConfig,
            weights: { ...preset.weights },
        };

        const confidence = computeLearningConfidence(historico, maxNum, numSorteados, config);
        if (!confidence) {
            return;
        }

        const benchmarkScore = scorePresetForLowPercentiles(confidence);
        if (benchmarkScore <= bestScore) {
            return;
        }

        const ranking = computeNumberLearningRankings(historico, maxNum, numSorteados, config);
        if (!ranking) {
            return;
        }

        bestScore = benchmarkScore;
        bestPreset = preset;
        bestResult = {
            ...ranking,
            confidence,
            selectedPreset: preset,
            benchmarkScore,
            presetsTested: WEIGHT_PRESETS.length,
        };
    });

    if (!bestResult || !bestPreset) {
        return null;
    }

    return {
        result: bestResult,
        selectedPreset: bestPreset,
        benchmarkScore: bestScore,
        presetsTested: WEIGHT_PRESETS.length,
    };
};
